export enum EmployerDashboardMatchType {
    applications = 'applications',
    invite = 'invite',
    invited = 'invited',
    inProgress = 'inProgress',
    archived = 'archived',
    allApproved = 'allApproved',
}
